import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IFixedDepositRequestsState {
  data?: {
    data?: any[]
    meta?: any
  }
  loading?: boolean
}

const initialState: IFixedDepositRequestsState = {
  data: {data: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: IFixedDepositRequestsState = initialState,
  action: ActionWithPayload<IFixedDepositRequestsState>
) => {
  switch (action.type) {
    case actionTypes.GET_FIXED_DEPOSIT_REQUESTS_START:
      return {...state, loading: true}
    case actionTypes.GET_FIXED_DEPOSIT_REQUESTS_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_FIXED_DEPOSIT_REQUESTS_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
